import React from "react";

import StaticPageStyles from "./static_pages.module.css"
import MainStyle from "../components/Style.module.css"
import InstagramWarning from "../components/InstagramWarning";

export default function PriceList_en() {
    return <div className={MainStyle.startPageMainWithBackground}>
        <InstagramWarning/>
        <div className={StaticPageStyles.pricePpage}>

            <div className={StaticPageStyles.priceContainer}>
                <br/>
                <h3>Current prices for hosting games on the LeelaOnline platform</h3>
                <h4 style={{textAlign:"left", marginLeft: "24px", paddingLeft: "0.5em", marginBottom: "-12px", backgroundColor: "white", zIndex:50, width:"10.5em"}}> Video Call Games</h4>
                <table className={StaticPageStyles.priceTable}>
                    <thead>
                    <th>Game Type</th>
                    <th>Price</th>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Hosting an individual game</td>
                        <td className={StaticPageStyles.priceCell}>3
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td>Hosting a personal game (for yourself)</td>
                        <td className={StaticPageStyles.priceCell}>0.5
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td><b>Hosting a group game</b></td>
                    </tr>
                    <tr>
                        <td> - game with 2 players</td>
                        <td className={StaticPageStyles.priceCell}>5
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td> - game with 3 players</td>
                        <td className={StaticPageStyles.priceCell}>7
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td> - game with 4 players</td>
                        <td className={StaticPageStyles.priceCell}>9
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td> - game with 5 players</td>
                        <td className={StaticPageStyles.priceCell}>10
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td> - game with 6 players</td>
                        <td className={StaticPageStyles.priceCell}>11
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h4 style={{textAlign:"left", marginLeft: "24px", paddingLeft: "0.5em", marginBottom: "-12px", backgroundColor: "white", zIndex:50, width:"11em"}}> Games w/o video call</h4>
                <table className={StaticPageStyles.priceTable}>
                    <thead>
                    <th>Game Type</th>
                    <th>Price</th>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Hosting an individual game</td>
                        <td className={StaticPageStyles.priceCell}>1
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td><b>Hosting a group game</b></td>
                    </tr>
                    <tr>
                        <td> - game with 2 players</td>
                        <td className={StaticPageStyles.priceCell}>2
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    <tr>
                        <td> - each additional player</td>
                        <td className={StaticPageStyles.priceCell}>0.5
                            <div className={StaticPageStyles.coinSmall}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <small style={{display: "flex", flexDirection: "row", justifyContent: "center"}}> ** <div
                    className={StaticPageStyles.coinSmall}/> is approximately equivalent to 1 EUR at the time of account top-up</small>
                <br/>
            </div>

        </div>
    </div>
}
